import {
  IPublicClientApplication,
  PublicClientApplication,
  InteractionType,
  LogLevel
} from "@azure/msal-browser";
import {
  MsalInterceptorConfiguration,
  MsalGuardConfiguration
} from "@azure/msal-angular";
import { environment } from "../../../../environments/environment";

export const msalDisabled = false;

export function loggerCallback(logLevel: LogLevel, message: string) {
  // noop
  // // console.log(message);
}

function _MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.auth.clientId,
      authority: `${environment.msalConfig.auth.authority}${environment.msalConfig.auth.tenantId}`,
      redirectUri: environment.msalConfig.auth.redirectUri,
      postLogoutRedirectUri: environment.msalConfig.auth.postLogoutRedirectUri,
      clientCapabilities: environment.msalConfig.auth.clientCapabilities, // this lets the resource owner know that this client is capable of handling claims challenge.
      navigateToLoginRequestUrl:
        environment.msalConfig.auth.navigateToLoginRequestUrl
    },
    cache: {
      cacheLocation: environment.msalConfig.cache.cacheLocation,
      storeAuthStateInCookie:
        environment.msalConfig.cache.storeAuthStateInCookie // Set his to "true" if you are having issues on IE11 or Edge
    },
    system: {
      allowNativeBroker: false, // Disables WAM Broker
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

function _MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(environment.msalConfig.graphUrl, [
    environment.msalConfig.apiScopes.MSAL_GRAPH
  ]);
  protectedResourceMap.set(
    environment.API_URL,
    environment.msalConfig.apiScopes.API_URL.map((scope) => {
      return `${scope.prefix}://${environment.msalConfig.auth.clientId}/${scope.permission}`;
    })
  );
  // Estendi anche per il planner tool
  if (environment.API_URL_PLANNER_TOOL) {
    protectedResourceMap.set(
      environment.API_URL_PLANNER_TOOL,
      environment.msalConfig.apiScopes.API_URL.map((scope) => {
        return `${scope.prefix}://${environment.msalConfig.auth.clientId}/${scope.permission}`;
      })
    );
  }

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

function _MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ["user.read", "mail", "openid", "profile", "email"]
    },
    loginFailedRoute: "/login-failed"
  };
}

export function MSALInstanceFactory() {
  return _MSALInstanceFactory();
}
export function MSALInterceptorConfigFactory() {
  return _MSALInterceptorConfigFactory();
}
export function MSALGuardConfigFactory() {
  return _MSALGuardConfigFactory();
}
